import { useMutation } from 'react-query';
import { useSnackbar } from '@goodfynd/context';
import type { PostApiOptions } from 'types/api';

export function usePostApi<TResult, TParams>({
  getSuccessMessage,
  request,
  showSuccessMessage = true,
  ...options
}: PostApiOptions<TResult, TParams>) {
  const { openSnackbarSuccess, openSnackbarWarning } = useSnackbar();

  const { data, isLoading, mutateAsync } = useMutation<TResult, Error, TParams>(
    request,
    {
      ...options,
      onError(error, ...args) {
        options?.onError?.(error, ...args);
        openSnackbarWarning({
          message: error?.message || 'An unknown error has occurred',
        });
      },
      onSuccess(data, ...args) {
        options?.onSuccess?.(data, ...args);

        if (showSuccessMessage) {
          openSnackbarSuccess({
            message: getSuccessMessage?.(data) ?? 'Created successfully!',
          });
        }
      },
    }
  );

  return {
    data,
    isPosting: isLoading,
    post: mutateAsync,
  };
}
